
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop title          标题内容
 * @prop bodyStyle      body style
*/
@Component({
    name: 'row-wrap'
})
export default class extends Vue {
    @Prop({ default: '' }) private title!: string
    @Prop({ default: '' }) private bodyStyle!: string | Object
    private titleSlot = false

    private created() {
        this.titleSlot = !!this.$slots.title
    }
}
